import { createRequestTypes } from '../shared/types';

export const USER = createRequestTypes('user', 'USER');
export const UPDATE = createRequestTypes('user', 'UPDATE');

export const USER_UPDATE = 'line-up/user/UPDATE';
export const LOAD = 'line-up/user/LOAD';

export const EXPORT_CUSTOMERS = 'line-up/customer/EXPORT';
